import { render, staticRenderFns } from "./WVuetifyColorPicker.vue?vue&type=template&id=6fac0c1e&scoped=true&"
import script from "./WVuetifyColorPicker.vue?vue&type=script&lang=js&"
export * from "./WVuetifyColorPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fac0c1e",
  null
  
)

export default component.exports